var map = {
	"./en/404.json": "0d03",
	"./en/brands.json": "367d",
	"./en/browser.json": "27fa",
	"./en/errors.json": "6a10",
	"./en/languages.json": "6397",
	"./en/login.json": "5b6d",
	"./en/messages.json": "3e74",
	"./en/navbar.json": "0f62",
	"./en/order.json": "9d46",
	"./en/orders.json": "94ec",
	"./en/password.json": "23d5",
	"./en/password_recover.json": "c6ab",
	"./en/settings.json": "0462",
	"./en/sidebar.json": "fc48",
	"./en/users.json": "7166",
	"./en/watch.json": "a804",
	"./es/404.json": "9bcf",
	"./es/brands.json": "53198",
	"./es/browser.json": "1f44",
	"./es/errors.json": "4f32",
	"./es/languages.json": "a5bd",
	"./es/login.json": "c669",
	"./es/messages.json": "210e",
	"./es/navbar.json": "2a38",
	"./es/order.json": "9c98",
	"./es/orders.json": "77b2",
	"./es/password.json": "b4cd",
	"./es/password_recover.json": "4127",
	"./es/settings.json": "21b6",
	"./es/sidebar.json": "d7ad",
	"./es/users.json": "cf76",
	"./es/watch.json": "d042"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "22cb";